import React from 'react';
import { Images } from 'utils';

/**
 * @param nameSuffix rendered on the name's line (e.g. a status badge)
 * @param children   rendered under the name, next to a larger avatar (e.g. contact badges + tags)
 * @param initials   shown in the avatar circle when there is no `src` (e.g. "A H"); without it, the default user image
 */
export const NameAndAvatar = ({ src, name, nameSuffix, children, initials, imageStyles={} }) => {
    const hasDetails = !!children;
    const avatarInitials = initials?.trim();

    return (
        <div className={`name-and-avatar-box${hasDetails ? ' with-details' : ''}`}>
            {/*{type === 'fundingSource' ? (*/}
            {/*    <img className="fs-source-image" src={Images.fsIcon} alt="avatar" />*/}
            {/*) : (*/}
                <div className="user-avatar">
                    {src || !avatarInitials ? (
                        <img src={src || Images.userProfile} alt="avatar" style={{ ...imageStyles }} />
                    ) : (
                        <p>{avatarInitials}</p>
                    )}
                </div>
            {/*)}*/}
            {hasDetails ? (
                <div className="name-and-avatar-details">
                    <div className="name-and-avatar-title">
                        <h1>{name}</h1>
                        {nameSuffix}
                    </div>
                    {children}
                </div>
            ) : (
                <>
                    <h1>{name}</h1>
                    {nameSuffix}
                </>
            )}
        </div>
    );
};
